import React, { useEffect, useState } from "react";
import styles from "./Hint.module.css";

function Hint({ title, description, image }) {
  useEffect(() => {}, []);

  function getTop(e) {
    if (e.target.closest(".hint__cont")) {
      const currentHint = e.target.closest(".hint__cont");
      currentHint.classList.replace("", "");
    }
  }
  function getDefault(e) {
    if (e.target.closest(".hint__cont")) {
      const currentHint = e.target.closest(".hint__cont");
      currentHint.classList.replace("", "");
    }
  }
  return (
    <div
      className={`${styles.hintCont}  hint__cont`}
      // onMouseEnter={(e) => getTop(e)}
      // onMouseLeave={(e) => getDefault(e)}
    >
      <div className={`${styles.hint} `}>
        <div className={styles.hintHead}>
          <h3>{title}</h3>
          <img src={image} alt="" />
        </div>

        <p>{description}</p>
      </div>
    </div>
  );
}

export default Hint;
